const E = {
  option: '-- Select a Language --',
  English: 'English',
  French: 'French',
};

const F = {
  option: '-- Sélectionnez une langue --',
  English: 'Anglais',
  French: 'Français',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/languages.js